/**
* Get the URL parameter value
*
* @param  name {string} パラメータのキー文字列
* @return  url {url} 対象のURL文字列（任意）
*/
function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

//モーダル
$(function(){
    $(".md-btn").each(function(){
        $(this).on('click',function(e){
            e.preventDefault();
            var target = $(this).data('target');
            var modal = document.getElementById(target);
            $(modal).find('.md-overlay,.md-contents').fadeIn();
            scrollPosition = $(window).scrollTop();
            $('body').addClass('fixed').css({'top': -scrollPosition});
        });
    });
    $('.md-close').on('click',function(){
        $('.md-overlay,.md-contents').fadeOut();
        $('body').removeClass('fixed').css({'top': 0});
		window.scrollTo( 0 , scrollPosition );
    });
});

//ズーム機能
$(function(){
    //「拡大ボタン」を押したら
    $('.zoom').on('click', function(){
        $(".target").css( { transform: "scale(2)" } );
        document.getElementById("zoom_btn_disabled_01").disabled = true;
        document.getElementById("zoom_btn_disabled_02").disabled = true;
        document.getElementById("zoom_btn_disabled_03").disabled = true;
    });
    //リセットorモーダルを閉じたら
    $('.zoom-init,.md-close').on('click', function(){
        $(".target").css( { transform: "scale(1)" } );
        document.getElementById("zoom_btn_disabled_01").disabled = false;
        document.getElementById("zoom_btn_disabled_02").disabled = false;
        document.getElementById("zoom_btn_disabled_03").disabled = false;
    });
});

//cookieによってbodyにクラス付与
$(function(){
    //cookieがbg_blackの場合
    if ($.cookie("bgcolor") == "bg_black") {
        $('body').addClass("tokyo-sodachi_bg_black");
    }
    //cookieがbg_blueの場合
    else if ($.cookie("bgcolor") == "bg_blue") {
        $('body').addClass("tokyo-sodachi_bg_blue");
    }
    //cookieが無い場合
    else{
        $('body').removeClass("tokyo-sodachi_bg_black");
        $('body').removeClass("tokyo-sodachi_bg_blue");
    }
});